export class Province {
  public id: number;
  public code: string;
  public country_id:number;
  public state_id:number;
  public name:string;
  public country:string;
  public state:string;
}



// WEBPACK FOOTER //
// ./src/app/models/province.model.ts